<template>
  <div id="bulk_upload" v-if="showModal" class="chartsModalWrapper">
    <!-- <div id="bulk_upload" class="chartsModalWrapper"> -->
    <div class="chart-modal-body">
      <div class="col-12 p-0 chartModalContainer">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Update Charts Data
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="col-12">
                <label class="col-12 p-0">
                  <div for="file" class="row doted-border">
                    <div class="upload-btn-wrapper button_position_middle">
                      <input
                        type="file"
                        name="fileUpload"
                        id="file"
                        title="No file selected"
                        @change="onFileChange"
                        ref="updateChartDataFile"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                      <span
                        type="button"
                        class="btn btn-primary addInfoButton k-button"
                      >
                        Choose file
                      </span>
                    </div>
                  </div>
                </label>
              </div>
            </form>
            <p
              :class="
                responceData.status == 200 || responceData.status == 201
                  ? 'text-success'
                  : 'text-danger'
              "
              class="p-0 m-0 mb-2"
            >
              {{ responceData.message }}
            </p>
            <table
              class="table m-0 p-2"
              v-if="
                selectedFile !== undefined &&
                  selectedFile.name &&
                  selectedFile.size
              "
            >
              <tr class="">
                <th>Name</th>
                <th>Size</th>
                <th>Action</th>
              </tr>
              <tr>
                <td>{{ selectedFile.name }}</td>
                <td>{{ selectedFile.size }}</td>
                <td>
                  <img
                    type="button"
                    @click="removeFile"
                    :src="deleteIconSrc"
                    alt="Delete Icon"
                  />
                </td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="handleSubmit">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import deleteIcon from "../../../assets/img/icons/delete.svg";

export default {
  name: "ChartsModal",
  components: {},
  props: {
    showCurrentChartId: Number,
  },
  data() {
    return {
      showModal: false,
      selectedFile: {},
      selectedFileValidate: true,
      deleteIconSrc: deleteIcon,
      responceData: {},
    };
  },
  computed: {
    ...mapGetters(["getIsShow", "historyCalDropDown", "currentChartName"]),
  },
  mounted() {
    // console.log("this.selectedFile", this.selectedFile);
  },
  updated() {},
  methods: {
    ...mapActions([
      "bulkUpload",
      "updateDownloadHandler",
      "chartUpdateUploadHandler",
    ]),
    closeModal() {
      this.showModal = false;
      this.responceData = {};
      this.removeFile();
      this.closeShowModal();
    },
    closeShowModal() {
      this.updateDownloadHandler(false);
    },
    handleShowModal() {
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = "fixed";
    },
    async handleSubmit(dataItem) {
      let formData = new FormData();
      formData.append(
        "chart_id",
        this.historyCalDropDown.current_version.chart_id
      );
      formData.append("chart_name", this.currentChartName);
      formData.append("file", this.selectedFile.value);
      // console.log("formData+++++formData", this.selectedFile);
      let request_data = await this.chartUpdateUploadHandler(formData);
      // console.log("=========================", request_data);
      this.responceData = request_data;
      if (request_data.status == 201 || request_data.status == 200) {
        this.selectedFile = {};
        setTimeout(() => {
          this.closeModal();
        }, 3000);
      }
    },
    getUploadedFileData(val) {
      if (val && val.length) {
        this.selectedFile = val;
        this.selectedFileValidate = false;
      } else {
        this.selectedFileValidate = true;
      }
      // console.log("getUploadedFileData------------getUploadedFileData", val);
    },
    // show toast----
    showToast(message, type) {
      this.$toast.open({
        message: message,
        type: type,
        duration: 3000,
        dismissible: true,
        position: "top",
      });
    },
    onFileChange() {
      // console.log("filessssssssssssss", files);
      let file = this.$refs.updateChartDataFile.files;
      if (file.length) {
        // this.selectedFile = file[0];
        this.selectedFile = {
          name: file[0].name,
          type: file[0].type,
          size: file[0].size,
          value: file[0],
        };
      }
    },
    removeFile() {
      this.selectedFile = {};
      this.$refs.updateChartDataFile.files = null;
    },
  },
  watch: {
    getIsShow: {
      deep: true,
      handler() {
        // console.log("999999999999999");
        this.showModal = this.getIsShow;
      },
    },
  },
};
</script>

<style lang="scss">
#bulk_upload.chartsModalWrapper {
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 100;
  //   background: #000000a1 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  opacity: 1;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6313725490196078) 0 0 no-repeat padding-box;
  .modal-content {
    border-radius: 0;
  }
  .modal-close-button {
    display: flex !important;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    height: 20px;
    padding: 0;
    img {
      width: 15px !important;
    }
  }
  .modal-header-blue-bg {
    background-color: #315ea5;
    color: #fff;
    padding: 10px;
    h5 {
      font-size: 16px;
      font-weight: 400;
    }
  }
  .chart-modal-body {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    height: 100%;
    max-width: 600px;
    margin: 0 auto;
  }
  .chartModalContainer {
    position: relative;
    // margin: calc(100vh - 96vh) auto;
    width: 100%;
    // height: 84vh;
    /* UI Properties */
    // background: #315EA5 0% 0% no-repeat padding-box;
    background-color: #fff;
    // opacity: 1;
    z-index: 110;
    box-shadow: 0px 0px 3px #0000004d;
    border-radius: 0;
    .evs_logo {
      max-width: 100px !important;
      height: 10px;
    }
  }
  .chartModalHeader {
    background-color: #fff;
    border-radius: 0;
    height: 40px;
    width: 100%;
    color: #202020;
    font-size: 14px;
    font-weight: bold;
    padding: 10px;
  }
  .modalBody {
    .k-form-fieldset .row .row {
      border: 1px dashed #ccc;
      margin-bottom: 15px;
    }
    .k-form-buttons {
      display: block;
    }
    .button_position_left {
      padding-left: 15px;
    }
    button.addInfoButton {
      background-color: #315ea5;
      border: 1px solid #315ea5;
    }
  }
}
.button_position_middle {
  margin: 16.5% auto;
}
.doted-border {
  border: 1px dotted #ccc;
}
#file {
  display: none;
}
table th,
table td {
  padding: 0.5rem;
  font-size: 12px;
}
</style>
